interface IPackageInfo {
  name: string;
  version: string;
  dependencies?: Record<string, string>;
  devDependencies?: Record<string, string>;
}

export function addPackageToWindowFrontiers(packageInfo: IPackageInfo) {
  if (import.meta.client) {
    if (!window.FRONTIERS) window.FRONTIERS = {};
    Object.assign(window.FRONTIERS, {
      [packageInfo.name]: packageInfo.version,
      dependencies: packageInfo.dependencies,
      devDependencies: packageInfo.devDependencies
    });
  }
}
